import { render, staticRenderFns } from "./CookiesUseForm.vue?vue&type=template&id=33ca834b"
import script from "./CookiesUseForm.vue?vue&type=script&lang=js"
export * from "./CookiesUseForm.vue?vue&type=script&lang=js"
import style0 from "./CookiesUseForm.vue?vue&type=style&index=0&id=33ca834b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports